<template>
	<div>
		<div v-for="(item, index) in fieldsArray" :key="item[index]">
			<div class="b1 bc7 p2 mt2 mb2 flex xs-between xs-middle">
				<div class="flex">
					<p class="mr2">{{ item.name ? item.name : "---" }}</p>
				</div>
				<div class="flex xs-right xs-middle">
					<p class="c7 mr2">{{ item.type.kind }}</p>
					<j-base-input-number
						v-if="item.type.kind === 'LIST'"
						v-model="indexModifier"
						size="xsmall"
						class="mr2 xs-2"
					/>
					<j-button
						size="xsmall"
						v-if="openedChildren !== index"
						@click.native="toggleShowChildren(item, index)"
						>{{ $t("select") }}</j-button
					>
					<j-button
						size="xsmall"
						type="error"
						v-if="openedChildren === index"
						@click.native="toggleHideChildren(item, index)"
						>{{ $t("deselect") }}</j-button
					>
				</div>
			</div>
			<field-item
				v-if="openedChildren === index"
				class="ml4"
				:types="types"
				:fieldsArray="findTypeFields(item)"
				@path:added="handleAdd"
				@path:removed="handleRemove"
			/>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton/"
import JBaseInputNumber from "@/components/JBaseInputNumber/"

export default {
	name: "FieldItem",

	components: {
		JButton,
		JBaseInputNumber
	},

	props: {
		fieldsArray: {
			type: Array
		},
		types: {
			type: Array
		}
	},

	data() {
		return {
			openedChildren: null,
			pathToAdd: null,
			modifiersToAdd: null,
			pathToRemove: null,
			indexModifier: 0
		}
	},

	methods: {
		findTypeFields(item) {
			const type = item?.type?.name
				? item?.type?.name
				: item?.type?.ofType?.name
			return this.types?.find(item => item?.name === type)?.fields
		},
		toggleShowChildren(item, index) {
			this.openedChildren = index
			this.pathToAdd = item
			this.decideModifiers(item)
			this.$emit("path:added", {
				payload: this.pathToAdd,
				modifiers: this.modifiersToAdd
			})
		},
		toggleHideChildren(item, index) {
			this.openedChildren = null
			this.pathToRemove = item
			this.resetModifiers() // reset index modifier
			this.$emit("path:removed", {
				payload: this.pathToRemove,
				modifiers: null
			})
		},
		handleAdd({ payload, modifiers }) {
			this.pathToAdd = payload
			this.$emit("path:added", {
				payload: this.pathToAdd,
				modifiers: modifiers
			})
		},
		handleRemove({ payload, modifiers }) {
			this.pathToRemove = payload
			this.$emit("path:removed", {
				payload: this.pathToRemove,
				modifiers: modifiers
			})
		},
		decideModifiers(item) {
			if (item.type.kind === "LIST") {
				this.modifiersToAdd = { index: this.indexModifier }
			}
		},
		resetModifiers() {
			this.indexModifier = 0
			this.modifiersToAdd = null
		}
	}
}
</script>
